var logoutRequest = null;
export function setLogoutRequest(requestData) {
    logoutRequest = requestData;
    if (logoutRequest !== null) {
        window.dispatchEvent(new CustomEvent("trigger-logout"));
    }
}
export function getLogoutRequest() {
    return logoutRequest;
}
